import React from "react";

import { api } from "src/common/utils/api";
import { useCreateGenericError } from "src/features/notifications";
import { useOrgModParams } from "src/features/orgmod";
import { usePatientIdParam } from "src/features/patient";

interface OrgInfo {
	code: string;
	dialysisCentre: boolean;
	address?: string;
	phoneNumber?: string;
}

export function useDialysisCentre(): {
	orgInfo?: OrgInfo;
} {
	const { org, mod } = useOrgModParams();
	const patientId = usePatientIdParam();

	const [isFetching, setFetching] = React.useState(false);
	const initial: { orgInfo?: OrgInfo } = {};
	const [kdOrg, setKdOrg] = React.useState({ ...initial });
	const createGenericError = useCreateGenericError();

	React.useEffect(() => {
		const fn = async (signal?: AbortSignal): Promise<void> => {
			setFetching(true);
			try {
				const { data } = await api.get<
					{
						module: string;
						organization: string;
						orgInfo?: OrgInfo;
					}[]
				>(
					`/patients/share/${patientId}?organization=${org}&module=${mod}`
				);
				if (signal === undefined || !signal.aborted) {
					setFetching(false);
					const found = data.find(
						item => item.orgInfo?.dialysisCentre
					);

					if (found) {
						setKdOrg(found);
					}
				}
			} catch {
				if (signal === undefined || !signal.aborted) {
					setFetching(false);
					createGenericError();
				}
			}
		};
		const controller = new AbortController();
		fn(controller.signal);
		return () => {
			controller.abort();
		};
	}, [org, mod, patientId, createGenericError]);

	if (isFetching || !kdOrg.orgInfo) {
		return {};
	}

	return kdOrg;
}
